module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAADCAYAAAB4bZQtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADJJREFUeNpilJWVnsnAwJAKxIwM1AP/gXg2I9DwP0AGMwP1wV8mIDEXahMDlV0+FyDAAH+6CHyW34dnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./img/minus-button.png
// module id = 878
// module chunks = 0